import { api } from '@repo/api-kit/capital-deposit';
import { client as qontoClient } from '../../../utils/client';
import { apiBaseURL } from '../../../constants/hosts';

const {
  ApiConfirmCapitalDepositBylawResponse,
  ApiDepositCapitalStatus,
  ApiGetCapitalDepositResponse,
  ApiPatchCapitalDepositResponse,
} = api.organizations.firstparty.v5;

/**
 * Fetches capital deposit data from GET /organizations/v5/:id/capital_deposit
 *
 * @param organizationId - Organization ID
 * @returns Promise with capital deposit data
 */
export async function fetchCapitalDepositData(organizationId: string) {
  const response = await qontoClient(
    `${apiBaseURL}/organizations/v5/${organizationId}/capital_deposit`
  );

  return ApiGetCapitalDepositResponse.fromJSON(response);
}

/**
 * Patches capital deposit data via PATCH /organizations/v5/:id/capital_deposit
 */
export async function patchCapitalDeposit(
  organizationId: string,
  data: { providerSource: string | null; providerSourceContactEmail: string | null }
) {
  const response = await qontoClient(
    `${apiBaseURL}/organizations/v5/${organizationId}/capital_deposit`,
    {
      method: 'PATCH',
      body: data,
    }
  );

  return ApiPatchCapitalDepositResponse.fromJSON(response);
}

/**
 * Confirms capital deposit bylaw annex generation via
 * POST /organizations/v5/:id/confirm_capital_deposit_bylaw
 *
 * @param organizationId - Organization ID
 * @param mergeBylawAnnex - Whether to merge the bylaw annex
 */
export async function confirmCapitalDepositBylaw(
  organizationId: string,
  { mergeBylawAnnex }: { mergeBylawAnnex: boolean }
) {
  const response = await qontoClient(
    `${apiBaseURL}/organizations/v5/${organizationId}/confirm_capital_deposit_bylaw`,
    {
      method: 'POST',
      body: { mergeBylawAnnex },
    }
  );

  return ApiConfirmCapitalDepositBylawResponse.fromJSON(response);
}

/**
 * Export the status enum for use in other parts of the application
 */
export { ApiDepositCapitalStatus };
